let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jEfvB")).then(() => parcelRequire('8lQN4'));